// extracted by mini-css-extract-plugin
export default {"linkButton":"columns_linkButton__h598i","clickableText":"columns_clickableText__uYtx-","titleCell":"columns_titleCell__Xod21","titleText":"columns_titleText__Itwn-"};